
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  selectedTroughListButton: {
    id: "SelectedTroughListButton.button",
    defaultMessage: "Trough added",
  }, 
});

export default MESSAGES;